// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { assetChainTestnet as _assetChainTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the assetChainTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 42421
 * Chain Name: AssetChain Testnet
 * Default Block Explorer: https://scan-testnet.assetchain.org
 * Default RPC URL: https://enugu-rpc.assetchain.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { assetChainTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: assetChainTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const assetChainTestnet = createCommon({
	..._assetChainTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
